<template>
    <div>
        <h1>Industries</h1>
    </div>
</template>

<script src="./industries.js"></script>
<style src="./industries.css"></style>